module.exports = __webpack_public_path__ + "media/images/ic-grid-white-661a97e0fa04d12932db3c6b102a9c6e.svg";